import { Alert as MuiAlert, Typography, styled } from '@mui/material';
import React from 'react';
import { ErrorIcon, InfoIcon, SuccessIcon, WarningIcon } from './icons/AlertIcons';

interface AlertProps {
  width?: string;
  title?: string;
  message: string;
  severity?: 'info' | 'error' | 'success' | 'warning';
}

const StyledAlert = styled(MuiAlert)<{ severity: 'info' | 'error' | 'success' | 'warning', width?: string }>(({ severity, width }) => ({
  backgroundColor: severity === 'info'
    ? '#5BAAFF'
    : severity === 'error'
      ? '#E9004A'
      : severity === 'success'
        ? '#0D9C33'
        : '#FFCF3E',
  color: '#475467',
  padding: '16px',
  border: 'none',
  alignItems: 'center',
  width: width || 'auto',
  '& .MuiAlert-icon': {
    color: "#FFFFFF",
    padding: 0,
    marginRight: '12px',
    display: 'flex',
    alignItems: 'center',
    height: 'auto',
  },
  '& .MuiAlert-message': {
    padding: 0,
    verticalAlign: 'middle',
  },
}));

const Title = styled(Typography)({
  fontSize: '19px',
  fontWeight: 500,
  color: '#FFFFFF',
  lineHeight: '100%',
});

const Message = styled(Typography)({
  fontSize: '13.5px',
  color: '#FFFFFF',
  lineHeight: '100%',
  fontWeight: 500,
});

const getIcon = (severity: 'info' | 'error' | 'success' | 'warning') => {
  switch (severity) {
    case 'info':
      return <InfoIcon />;
    case 'error':
      return <ErrorIcon />;
    case 'success':
      return <SuccessIcon />;
    case 'warning':
      return <WarningIcon />;
  }
};

const Alert: React.FC<AlertProps> = ({ title, message, severity = 'info', width }) => {
  return (
    <StyledAlert
      icon={getIcon(severity)}
      severity={severity}
      width={width}
    >
      <Title>{title || severity.charAt(0).toUpperCase() + severity.slice(1)}</Title>
      <Message>{message}</Message>
    </StyledAlert>
  );
};

export default Alert; 